import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Container,
  Row,
  Col,
  Input,
  InputGroup,
  InputGroupAddon,
  Button,
  Alert,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalBody,
} from "reactstrap";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import NavigationLeft from "./NavigationLeft";
import * as actions from "../actions";
import axios from "axios";
import { BASE_URL, IMAGE_URL } from "../actions/types";
import AdultSizeTable from "./utils/AdultSizeTable";
import AdultShirtTable from "./utils/AdultShirtTable";
import LegginsTable from "./utils/LegginsTable";

class Product extends Component {
  state = {
    id: "",
    main: "",
    sub: "",
    product: "",
    price: "",
    amountToAdd: 1,
    description: "",
    images: [],
    visible: false,
    properties: [],
    dropdownStates: {},
    dropdownSelections: {},
    AdultSizeTable: false,
    AdultShirtTable: false,
    LegginsTable: false,
    extraCharge: 0,
    CustomProperties: {},
    dropdownCustomProperties: false,
    CustomPropertiesValue: "",
    stock: 0,
    modal: false,
    img: undefined,
    extras: {},
  };

  async getProductDetails(main, sub, product) {
    const productEncoded = decodeURIComponent(product);
    const subEncoded = sub;
    const data = await axios.post(`${BASE_URL}/getProduct`, {
      main,
      sub: subEncoded,
      product: productEncoded,
    });
    return data.data;
  }

  toggleModal = (img = undefined) => {
    this.setState({ modal: !this.state.modal, img });
  };

  async componentDidMount() {
    const url = this.props.location.pathname.split("/").filter((elem) => {
      return elem !== "";
    });

    const details = await this.getProductDetails(url[0], url[1], url[2]);
    let images;
    if (!details.images.length) {
      images = [];
    } else {
      images = details.images;
    }

    const DDStates = {};
    const DDSelections = {};

    details.Properties.map((p) => {
      DDStates[p] = false;
      DDSelections[p] = false;
      return null;
    });

    this.setState({
      details,
      id: details._id,
      main: url[0],
      sub: url[1],
      product: decodeURIComponent(url[2]),
      price: details.price,
      description: details.description,
      properties: details.Properties,
      dropdownStates: DDStates,
      dropdownSelections: DDSelections,
      dropdownError: "",
      images,
      AdultSizeTable: details.AdultSizeTable,
      AdultShirtTable: details.AdultShirtTable,
      LegginsTable: details.LegginsTable,
      CustomProperties: details.CustomProperties,
      stock: details.stock,
    });

    if (
      !this.props.categories.category_description.products.length ||
      this.props.categories.category_description.products[0].ParentCategory !== url[0] ||
      this.props.categories.category_description.products[0].SubCategory !== url[1]
    ) {
      this.props.getCategory({ main: url[0], sub: url[1] });
    }
  }

  async componentDidUpdate(prevProps) {
    if (this.props.location.pathname === prevProps.location.pathname) {
      return;
    }

    const details = this.props.categories.category_description.products[this.props.location.index + 1];
    const url = this.props.location.pathname.split("/").filter((elem) => {
      return elem !== "";
    });
    const DDStates = {};
    const DDSelections = {};

    details.Properties.map((p) => {
      DDStates[p] = false;
      DDSelections[p] = false;
      return null;
    });
    let images;
    if (!details.images.length) {
      images = [];
    } else {
      images = details.images;
    }
    await this.setState({
      details,
      id: details._id,
      main: url[0],
      sub: url[1],
      product: decodeURIComponent(url[2]),
      price: details.price,
      description: details.description,
      properties: details.Properties,
      dropdownStates: DDStates,
      dropdownSelections: DDSelections,
      dropdownError: "",
      images,
      AdultSizeTable: details.AdultSizeTable,
      AdultShirtTable: details.AdultShirtTable,
      LegginsTable: details.LegginsTable,
      CustomProperties: details.CustomProperties,
      stock: details.stock,
    });
    this.forceUpdate();
  }

  showImages() {
    if (!this.state.images || !this.state.images.length) {
      return <div />;
    }

    const images = this.state.images;
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
    };
    return (
      <Slider {...settings} className="productSlider">
        {images.map((image, i) => {
          return (
            <div key={image}>
              <img
                style={{ cursor: "pointer" }}
                width={"350px"}
                onClick={() => this.toggleModal(image)}
                src={`${IMAGE_URL}/${image}`}
                alt={i}
              />
            </div>
          );
        })}
      </Slider>
    );
  }

  updateAmount() {
    this.setState({
      amountToAdd: parseInt(document.getElementById("am").value, 10),
    });
  }

  addToBasket() {
    const hasFalseKeys = Object.keys(this.state.dropdownSelections).some((k) => {
      return !this.state.dropdownSelections[k];
    });

    console.log(hasFalseKeys);

    if (hasFalseKeys) {
      return this.setState({ dropdownError: "Valitse ominaisuudet" });
    }

    if (this.state.CustomProperties.values.length && !this.state.CustomPropertiesValue) {
      return this.setState({ dropdownError: "Valitse ominaisuudet" });
    }

    if (this.state.amountToAdd > this.state.stock) {
      return this.setState({
        dropdownError: `Tuotetta ei ole riittävästi varastossa.`,
      });
    }

    const details = [];

    for (var key in this.state.dropdownSelections) {
      if (this.state.dropdownSelections.hasOwnProperty(key)) {
        const property = this.props.categories.properties.filter((p) => p.identifier === key);

        details.push(property[0].title + ": " + this.state.dropdownSelections[key]);
      }
    }

    if (this.state.CustomProperties.values.length) {
      details.push(this.state.CustomProperties.title + ": " + this.state.CustomPropertiesValue);
    }

    this.props.addToBasket(this.state, details);
    this.setState({ visible: true, dropdownError: "" });
  }

  toggle = (dd) => {
    const DDState = this.state.dropdownStates;
    DDState[dd] = !this.state.dropdownStates[dd];
    this.setState({ dropdownStates: DDState });
  };

  toggleCustomProperties = () => {
    this.setState({
      dropdownCustomProperties: !this.state.dropdownCustomProperties,
    });
  };

  handleSelect = async (id, val, extra, hasExtra) => {
    const values = this.state.dropdownSelections;
    console.log("oioioioi");
    console.log(values);
    values[id] = val;
    await this.setState({ dropdownSelections: values });
    const { dropdownSelections } = this.state;
    const { properties } = this.props.categories;

    console.log(id);
    console.log(extra);

    await this.setState({ extras: { ...this.state.extras, [id]: extra } });

    let ex = 0;

    const keys = Object.keys(this.state.extras);

    keys.forEach((key) => {
      ex += this.state.extras[key];
    });

    // if (extra) {
    //   ex = extra;
    // }

    // for (let key in dropdownSelections) {
    //   console.log(dropdownSelections);
    //   if (values[key]) {
    //     const v = properties.find((p) => p.title === key);
    //     console.log(v);
    //     if (v && v.extraCharge.length) {
    //       const selected = dropdownSelections[key];
    //       const { extraCharge } = v;
    //       const ext = extraCharge.find((e) => e.value === selected);
    //       if (ext) {
    //         ex = ex + ext.charge;
    //       }
    //     }
    //   }
    // }
    if (hasExtra) {
      await this.setState({
        price: parseInt(this.state.details.price) + parseInt(ex),
      });
    }
  };

  handleCustomSelect = (val) => {
    this.setState({ CustomPropertiesValue: val });
  };

  renderPropertiesSelections() {
    return this.state.properties.map((property) => {
      const selection = this.props.categories.properties.filter((p) => p.identifier === property);
      const sel = selection[0];
      if (sel && sel.type === "dropdown") {
        return (
          <div key={sel.identifier}>
            <Dropdown
              isOpen={this.state.dropdownStates[sel.identifier]}
              toggle={() => this.toggle(sel.identifier)}
            >
              <DropdownToggle caret>
                {this.state.dropdownSelections[sel.identifier] || sel.title}
              </DropdownToggle>
              <DropdownMenu>
                {sel.values.map((v) => {
                  let extra = "";
                  let extraInt = 0;
                  if (sel.extraCharge) {
                    const EC = sel.extraCharge.filter((e) => e.value === v);
                    if (EC.length) {
                      extra = `(+${EC[0].charge}€)`;
                      extraInt = EC[0].charge;
                    }
                  }
                  return (
                    <DropdownItem
                      onClick={() => {
                        this.handleSelect(sel.identifier, v, extraInt, Boolean(sel.extraCharge.length));
                      }}
                      key={v}
                    >
                      {v} {extra}
                    </DropdownItem>
                  );
                })}
              </DropdownMenu>
            </Dropdown>
            <br />
          </div>
        );
      } else {
        return null;
      }
    });
  }

  renderCustomProperties = () => {
    if (this.state.CustomProperties.values.length) {
      return (
        <div>
          <Dropdown
            isOpen={this.state.dropdownCustomProperties}
            toggle={() => this.toggleCustomProperties()}
          >
            <DropdownToggle caret>
              {this.state.CustomPropertiesValue || this.state.CustomProperties.title}
            </DropdownToggle>
            <DropdownMenu>
              {this.state.CustomProperties.values.map((v) => {
                return (
                  <DropdownItem
                    onClick={() => {
                      this.handleCustomSelect(v);
                    }}
                    key={v}
                  >
                    {v}
                  </DropdownItem>
                );
              })}
            </DropdownMenu>
          </Dropdown>
          <br />
        </div>
      );
    } else return <div />;
  };

  renderDropDownError = () => {
    if (this.state.dropdownError) {
      return <Alert color="danger">{this.state.dropdownError}</Alert>;
    }
    return null;
  };

  renderAdultSizeTable = () => {
    if (this.state.AdultSizeTable) {
      return <AdultSizeTable />;
    } else return <div />;
  };

  renderAdultShirtTable = () => {
    if (this.state.AdultShirtTable) {
      return <AdultShirtTable />;
    } else return <div />;
  };

  renderLegginsTable = () => {
    if (this.state.LegginsTable) {
      return <LegginsTable />;
    } else return <div />;
  };

  renderAddButton = () => {
    if (this.state.stock) {
      return (
        <InputGroup>
          <InputGroupAddon addonType="prepend">
            <Input
              className="addAmount"
              type="number"
              placeholder="1"
              id="am"
              step="1"
              min="1"
              max={this.state.stock}
              onClick={() => this.updateAmount()}
              onChange={() => this.updateAmount()}
            />
          </InputGroupAddon>
          <Button color="secondary" onClick={() => this.addToBasket()}>
            Lisää koriin!
          </Button>
          <Alert style={{ margin: "5px", padding: "5px" }} color="success" isOpen={this.state.visible}>
            Tuote lisätty koriin!
          </Alert>
        </InputGroup>
      );
    } else {
      return <Button color="secondary">Tilapäisesti loppu!</Button>;
    }
  };

  renderNextPrev = () => {
    //    this.props.getCategory({ main: url[0], sub: url[1] });

    const { products } = this.props.categories.category_description;
    const n = products.length;

    let j = 0;
    if (n > 0) {
      products.find((element, index) => {
        if (
          element.ParentCategory === this.state.main &&
          element.SubCategory === this.state.sub &&
          decodeURIComponent(element.name) === this.state.product
        ) {
          j = index;
          return index;
        }
        return false;
      });

      const nextlink =
        j < n - 1
          ? `/${products[j + 1].ParentCategory}/${products[j + 1].SubCategory}/${products[j + 1].name}`
          : "";

      const prevlink =
        j > 0
          ? `/${products[j - 1].ParentCategory}/${products[j - 1].SubCategory}/${products[j - 1].name}`
          : "";

      const prev =
        j > 0 ? (
          <Link to={{ pathname: prevlink, index: j - 2 }}>
            <Button>Edellinen</Button>
          </Link>
        ) : (
          ""
        );

      const back = (
        <Link to={`/${products[j].ParentCategory}/${products[j].SubCategory}`}>
          <Button>Tuotelistaukseen</Button>
        </Link>
      );

      const next =
        j === n - 1 ? (
          ""
        ) : (
          <Link to={{ pathname: nextlink, index: j }}>
            <Button>Seuraava</Button>
          </Link>
        );

      return (
        <div>
          {prev} {back} {next}
        </div>
      );
    }
  };
  render() {
    if (!this.props.categories.categories_descriptions[this.state.main]) {
      return <div />;
    }
    const desc = { __html: this.state.description };
    return (
      <div>
        <Modal size="lg" isOpen={this.state.modal} toggle={() => this.toggleModal(undefined)}>
          <ModalBody>
            <img
              style={{ cursor: "pointer" }}
              width={"100%"}
              src={this.state.img !== undefined ? `${IMAGE_URL}/${this.state.img}` : ""}
            />
          </ModalBody>
        </Modal>
        <Container>
          <Row style={{ textAlign: "center" }}>
            <Col xs="12">
              <NavigationLeft
                page={this.state.main}
                categories={this.props.categories.categories_menu[this.state.main].categories}
                numberOfProducts={
                  this.props.categories.categories_menu[this.state.main].numberOfProducts
                }
                location={this.props.location}
              />
            </Col>
          </Row>
        </Container>
        <Container>
          <Row>
            <Col xs="12" className="CategoryMainDesctiption">
              <h3 className="navigationLink">
                <Link to={`/${this.state.main}`}>{this.state.main}</Link> -{" "}
                <Link to={`/${this.state.main}/${this.state.sub}`}>{this.state.sub}</Link>
              </h3>
              <h1>
                {this.state.product} - {this.state.price}€
              </h1>
              <Row>
                <Col xs="12" lg="6">
                  {this.showImages()}
                </Col>
                <Col xs="12" lg="6">
                  <div dangerouslySetInnerHTML={desc} />

                  {this.renderPropertiesSelections()}
                  {this.renderCustomProperties()}
                  {this.renderDropDownError()}
                  {this.renderAddButton()}

                  {this.renderAdultSizeTable()}
                  {this.renderAdultShirtTable()}
                  {this.renderLegginsTable()}
                </Col>
              </Row>
            </Col>
            <Col style={{ marginTop: "5px" }} xs="12">
              {this.renderNextPrev()}
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

function mapStateToProps({ categories }) {
  return { categories };
}

export default connect(mapStateToProps, actions)(Product);
